import UserPrivateComponent from "@/components/PrivacyComponent/UserPrivateComponent";
import { loadAllAgent } from "@/redux/rtk/features/CRM/agent/agentSlice";
import { loadAllContact } from "@/redux/rtk/features/CRM/contact/contactSlice";
import {
  addNote,
  loadAllNotePaginated,
} from "@/redux/rtk/features/CRM/note/noteSlice";
import { loadAllOpportunity } from "@/redux/rtk/features/CRM/opportunity/opportunitySlice";
import { loadAllQuote } from "@/redux/rtk/features/quote/quoteSlice";
import { loadAllStaff } from "@/redux/rtk/features/hrm/user/userSlice";
import { Button, Form, Input, Select, Mentions } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BigDrawer from "@/components/Drawer/BigDrawer";
import AddCompany from "../Company/AddCompany";
import AddContact from "../Contact/AddContact";
import AddOpportunity from "../Opportunity/AddOpportunity";
import AddQuote from "../Quote/AddQuote";
import { useTranslation } from "react-i18next";

export default function AddNote({ createAs, drawer }) {
  const { t } = useTranslation();
  // selector
  const { list: companyList, loading: companyLoading } = useSelector(
    (state) => state.agent
  );
  const { list: contactList, loading: contactLoading } = useSelector(
    (state) => state.contact
  );
  const { list: opportunityList, loading: opportunityLoading } = useSelector(
    (state) => state.opportunity
  );

  const { list: quoteList, loading: quoteLoading } = useSelector(
    (state) => state.quote
  );
  const { list: staffList, loading: staffLoading } = useSelector(
    (state) => state.users
  );

  const userId = localStorage.getItem("id");
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    dispatch(loadAllContact());
    dispatch(loadAllAgent());
    dispatch(loadAllOpportunity());
    dispatch(loadAllQuote());
    dispatch(loadAllStaff({ query: "all" }));
  }, [dispatch]);

  const onFinish = async (values) => {
    try {
      setLoader(true);
      
      const mentionedUserIds = [];
      if (values.description && staffList) {
        const matches = values.description.match(/@([a-zA-Z0-9._]+)/g);
        if (matches) {
          matches.forEach(match => {
            const username = match.substring(1);
            const staff = staffList.find(s => 
              s.username === username || 
              `${s.firstName}.${s.lastName}`.toLowerCase() === username.toLowerCase()
            );
            if (staff && !mentionedUserIds.includes(staff.id)) {
              mentionedUserIds.push(staff.id);
            }
          });
        }
      }

      const formData = {
        ...values,
        noteOwnerId: values.noteOwnerId ? parseInt(values.noteOwnerId) : null,
        companyId: values.companyId ? parseInt(values.companyId) : null,
        opportunityId: values.opportunityId ? parseInt(values.opportunityId) : null,
        contactId: values.contactId ? parseInt(values.contactId) : null,
        quoteId: values.quoteId ? parseInt(values.quoteId) : null,
        dealId: values.dealId ? parseInt(values.dealId) : null,
        mentionedUserIds,
      };

      const resp = await dispatch(addNote(formData));
      if (resp?.payload?.message === "success") {
        form.resetFields();
        if (createAs) {
          if (typeof createAs.singleLoadThunk === "function") {
            const result = createAs.singleLoadThunk(createAs.id);
            if (typeof result === "function") {
              dispatch(result);
            }
          }
        } else {
          dispatch(loadAllNotePaginated({}));
        }
      }
    } catch (error) {
      console.error("Note creation failed:", error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (userId) {
      form.setFieldsValue({
        noteOwnerId: parseInt(userId),
      });
    }
  }, [form, userId]);
  return (
    <div className="flex justify-center mt-2 px-6 pb-6">
      <UserPrivateComponent permission="create-note">
        <Form
          className="w-full"
          onFinish={onFinish}
          layout="vertical"
          form={form}
          initialValues={createAs?.values}>
          <Form.Item hidden name="noteOwnerId" />
          <Form.Item hidden name="companyId" />
          <Form.Item hidden name="dealId" />
          <Form.Item hidden name="opportunityId" />
          <Form.Item hidden name="contactId" />
          <Form.Item hidden name="quoteId" />
          
          <Form.Item
            style={{ width: "100%" }}
            label={t("note.noteTitle")}
            name="title"
            rules={[{ required: true, message: t("note.titleRequired") }]}>
            <Input placeholder={t("note.titlePlaceholder")} />
          </Form.Item>

          <Form.Item label={t("note.descriptionLabel")} name="description">
            <Mentions
              placeholder={t("note.descriptionPlaceholder")}
              rows={4}
              options={staffList?.map(staff => ({
                value: staff.username || `${staff.firstName}.${staff.lastName}`,
                label: `${staff.firstName} ${staff.lastName}`,
              }))}
            />
          </Form.Item>

          <Form.Item label="">
            <div className="flex items-center gap-2">
              <Button
                loading={loader}
                size={"large"}
                htmlType="submit"
                type="primary">
                {t("common.create")}
              </Button>
            </div>
          </Form.Item>
        </Form>
      </UserPrivateComponent>
    </div>
  );
}
